import { DEFAULT_LOCALE } from "./i18n.config";

/**
 * Resolves the active locale using the following priority order:
 *
 * 1. Saved user preference (passed in as `savedPreference`)
 * 2. Browser language (`navigator.language`)
 * 3. Default fallback locale (`en-US`)
 *
 * The saved preference and browser locale are trusted as-is — the authoritative
 * list of supported locales comes from the runtime `/api/v1/locales` API, so we
 * do not validate against a static set here (which would reject valid locales
 * like "da-DK" that are not in the static fallback list).
 *
 * @param savedPreference - Locale string stored in ecm-preferences (key: "locale"), or null
 * @returns A BCP 47 locale code
 */
export function getLocale(savedPreference: string | null): string {
    // 1. Saved user preference — trust it directly
    if (savedPreference) return savedPreference;

    // 2. Browser language
    const browserLocale = navigator.language;
    if (browserLocale) return browserLocale;

    // 3. Default fallback
    return DEFAULT_LOCALE;
}
